import { getBranchId } from "../../utils/branch";
import { put, call, takeLatest, all } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { getDriverAttendanceApi, approveAttendanceApi, approveLogoutApi, leaveApproveApi, revertLogoutApi, revertLoginApi, getLogoutDetailsApi, holdDutyApi, releaseHoldCabApi, resumeDutyCabApi, editDriverLocationApi, makeCabAvailableApi } from "../../utils/DriverAttendence/DriverAttendence";
import { EDIT_DRIVER_LOCATION_REQUEST, editDriverLocationFailure, editDriverLocationSuccess, HOLD_DUTY_FAILURE, HOLD_DUTY_SUCCESS, MAKE_CAB_AVAILABLE_REQUEST, makeCabAvailableFailure, makeCabAvailableSuccess, RELEASE_HOLD_CAB_FAILURE, RELEASE_HOLD_CAB_REQUEST, RELEASE_HOLD_CAB_SUCCESS, RESUME_DUTY_CAB_FAILURE, RESUME_DUTY_CAB_REQUEST, RESUME_DUTY_CAB_SUCCESS } from "../actions/driverAttendenceAction";

interface DriverAttendancePayload {
    branchid: string;
    openingKM: string;
}

interface LeaveApprovePayload {
    cabid: string;
    reason: string;
    fromdate: string;
    todate: string;
}

interface RevertLogoutPayload {
    cabid: string;
    employeename: string;
}

interface RevertLoginPayload {
    cabid: string;
    employeename: string;
}

function* getDriverAttendanceSaga(
    action: PayloadAction<DriverAttendancePayload>
): Generator {
    try {
        const { branchid, openingKM } = action.payload;

        const response = yield call(
            getDriverAttendanceApi,
            branchid,
            openingKM
        );

        yield put({
            type: "GET_DRIVER_ATTENDANCE_SUCCESS",
            payload: (response as any).data,
        });
    } catch (error) {
        const err = error as Error;
        yield put({
            type: "GET_DRIVER_ATTENDANCE_FAILURE",
            payload: err.message,
        });
    }
}

function* approveAttendanceSaga(
    action: PayloadAction<{ cabid: string; openingKM: string; employeename: string }>
): Generator {
    try {
        const { cabid, openingKM, employeename } = action.payload;

        const response = yield call(
            approveAttendanceApi,
            cabid,
            openingKM,
            employeename
        );

        yield put({
            type: "APPROVE_ATTENDANCE_SUCCESS",
            payload: (response as any).data?.message || "Attendance approved successfully",
        });
    } catch (error) {
        const err = error as Error;
        yield put({
            type: "APPROVE_ATTENDANCE_FAILURE",
            payload: err.message,
        });
    }
}


//logout saga
function* approveLogoutSaga(
    action: PayloadAction<{ cabid: string; closingKM: string; employeename: string }>
): Generator {
    try {
        const { cabid, closingKM, employeename } = action.payload;

        const response = yield call(
            approveLogoutApi,
            cabid,
            closingKM,
            employeename
        );

        yield put({
            type: "APPROVE_LOGOUT_SUCCESS",
            payload: (response as any).data?.message || "Logout approved successfully",
        });
    } catch (error) {
        const err = error as Error;
        yield put({
            type: "APPROVE_LOGOUT_FAILURE",
            payload: err.message,
        });
    }
}


function* leaveApproveSaga(
    action: PayloadAction<LeaveApprovePayload>
): Generator {
    try {
        const { cabid, reason, fromdate, todate } = action.payload;

        const response = yield call(
            leaveApproveApi,
            cabid,
            reason,
            fromdate,
            todate
        );

        yield put({
            type: "LEAVE_APPROVE_SUCCESS",
            payload: (response as any).data.message,
        });
    } catch (error) {
        const err = error as Error;
        yield put({
            type: "LEAVE_APPROVE_FAILURE",
            payload: err.message,
        });
    }
}

function* revertLogoutSaga(
    action: PayloadAction<RevertLogoutPayload>
): Generator {
    try {
        const { cabid, employeename } = action.payload;

        const response = yield call(
            revertLogoutApi,
            cabid,
            employeename
        );

        yield put({
            type: "REVERT_LOGOUT_SUCCESS",
            payload: (response as any).data.message,
        });
    } catch (error) {
        const err = error as Error;
        yield put({
            type: "REVERT_LOGOUT_FAILURE",
            payload: err.message,
        });
    }
}

function* revertLoginSaga(
    action: PayloadAction<RevertLoginPayload>
): Generator {
    try {
        const { cabid, employeename } = action.payload;

        const response = yield call(
            revertLoginApi,
            cabid,
            employeename
        );

        yield put({
            type: "REVERT_LOGIN_SUCCESS",
            payload: (response as any).data.message,
        });
    } catch (error) {
        const err = error as Error;
        yield put({
            type: "REVERT_LOGIN_FAILURE",
            payload: err.message,
        });
    }
}

function* getLogoutDetailsSaga(
    action: PayloadAction<{ cabid: string }>
): Generator {
    try {
        const { cabid } = action.payload;
        const response = yield call(getLogoutDetailsApi, cabid);
        const data = (response as any).data.data || (response as any).data;
        yield put({
            type: "GET_LOGOUT_DETAILS_SUCCESS",
            payload: data,
        });
    } catch (error) {
        const err = error as Error;
        yield put({
            type: "GET_LOGOUT_DETAILS_FAILURE",
            payload: err.message,
        });
    }
}

function* holdDutySaga(action: any): Generator<any, void, any> {
    try {
        const { cabid, employeename, reason } = action.payload;
        const response = yield call(holdDutyApi, cabid, employeename, reason);

        if (response?.data?.status === 200) {
            yield put({ type: HOLD_DUTY_SUCCESS, payload: response.data.message });
        } else {
            yield put({ type: HOLD_DUTY_FAILURE, payload: response?.data?.message || "Hold failed" });
        }
    } catch (error: any) {
        yield put({ type: HOLD_DUTY_FAILURE, payload: error?.message || "Something went wrong" });
    }
}

function* handleReleaseHoldCab(action: any): Generator<any, void, any> {
    try {
        const { cabid, employeename } = action.payload;
        const response = yield call(releaseHoldCabApi, cabid, employeename);

        if (response?.data?.status === 200) {
            yield put({ type: RELEASE_HOLD_CAB_SUCCESS, payload: response.data.message });
        } else {
            yield put({ type: RELEASE_HOLD_CAB_FAILURE, payload: response?.data?.message || "Release failed" });
        }
    } catch (error: any) {
        yield put({
            type: RELEASE_HOLD_CAB_FAILURE,
            payload: error?.response?.data?.message || "Failed to release hold",
        });
    }
}

function* resumeDutyCabSaga(action: any): Generator<any, void, any> {
    try {
        const { cabid, employeename } = action.payload;
        const response = yield call(resumeDutyCabApi, cabid, employeename);

        if (response?.data?.status === 200) {
            yield put({ type: RESUME_DUTY_CAB_SUCCESS, payload: response.data.message });
        } else {
            yield put({ type: RESUME_DUTY_CAB_FAILURE, payload: response?.data?.message || "Resume failed" });
        }
    } catch (error: any) {
        yield put({
            type: RESUME_DUTY_CAB_FAILURE,
            payload: error?.response?.data?.message || "Failed to resume duty",
        });
    }
}

function* editDriverLocationSaga(action: any): any {
    try {
        const { cabid, piclat, piclon, present_location, locationupdatedby } = action.payload;
        const response = yield call(
            editDriverLocationApi,
            cabid,
            piclat,
            piclon,
            present_location,
            locationupdatedby
        );
        yield put(editDriverLocationSuccess(response.data));
    } catch (error: any) {
        yield put(editDriverLocationFailure(error?.response?.data || error.message));
    }
}

function* makeCabAvailableSaga(action: any): any {
    try {
        const { cabid } = action.payload;
        const response = yield call(makeCabAvailableApi, cabid);

        yield put(makeCabAvailableSuccess(response.data));

        yield put({
            type: "GET_DRIVER_ATTENDANCE_REQUEST",
            payload: {
                // A saga cannot use hooks, so read the shared getter directly.
                branchid: getBranchId(),
                openingKM: "0",
            },
        });

    } catch (error: any) {
        yield put(makeCabAvailableFailure(error?.response?.data || error.message));
    }
}



export function* watchDriverAttendance() {
    yield all([
        takeLatest("GET_DRIVER_ATTENDANCE_REQUEST" as const, getDriverAttendanceSaga),
        takeLatest("APPROVE_ATTENDANCE_REQUEST" as const, approveAttendanceSaga),
        takeLatest("APPROVE_LOGOUT_REQUEST" as const, approveLogoutSaga),
        takeLatest("LEAVE_APPROVE_REQUEST" as const, leaveApproveSaga),
        takeLatest("REVERT_LOGOUT_REQUEST" as const, revertLogoutSaga),
        takeLatest("REVERT_LOGIN_REQUEST" as const, revertLoginSaga),
        takeLatest("GET_LOGOUT_DETAILS_REQUEST" as const, getLogoutDetailsSaga),
        takeLatest("HOLD_DUTY_REQUEST" as const, holdDutySaga),
        takeLatest(RELEASE_HOLD_CAB_REQUEST, handleReleaseHoldCab),
        takeLatest(RESUME_DUTY_CAB_REQUEST, resumeDutyCabSaga),
        takeLatest(EDIT_DRIVER_LOCATION_REQUEST, editDriverLocationSaga),
        takeLatest(MAKE_CAB_AVAILABLE_REQUEST, makeCabAvailableSaga),
    ]);
}